import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'

export default function WelcomeLicensedCard({ user, showAddTeamMember, showAddLocation}) {
  let fullName = `${user.firstName} ${user.lastName}`

  if (user.credentials) {
    fullName = `${fullName}, ${user.credentials}`
  }

  return (
    <Card className='border-0 axs-shadow axs-rounded h-100'>
      <Card.Body className='py-5 px-4 mx-3 d-flex flex-column justify-content-around'>
        <Row>
          <Col className='text-center'>
            <h6>{fullName} was successfully added to your organization!</h6>
            <span className='text-muted font-weight-light'>An account setup email has been sent.</span>
          </Col>
        </Row>
        <br />
        <Row>
          <Col className='text-center mt-4 mb-5'>
            <i className="fas fa-check-circle fa-lg" style={{color: '#1ab2e9', fontSize: '5em'}}></i>
          </Col>
        </Row>
        <br />
        <Row className='font-weight-light'>
          <Col className='pr-5'>
            <Row>
              <Col>
                Team Members
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                By creating a {`${user.firstName} ${user.lastName}`} Team, any notifications to the licensed user will be delivered to the team members for a quicker response. The licensed user can continue to receive notification if desired.
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Button onClick={showAddTeamMember} block variant='success'>Add Team Members</Button>
              </Col>
            </Row>
          </Col>

          {/* <Col className='d-flex flex-column justify-content-between'>
            <div>
              <Row>
                <Col>
                  Locations
                </Col>
              </Row>
              <br />
              <Row>
                <Col>
                  Add {`${user.firstName} ${user.lastName}`} to the physical location where the licensed user will engage with patients.
                </Col>
              </Row>
            </div>
            <br />
            <Row>
              <Col>
                <Button onClick={showAddLocation} block variant='success'>Assign Location</Button>
              </Col>
            </Row>
          </Col> */}

        </Row>
      </Card.Body>
    </Card>
  )
}
